import React from 'react';
import { useTranslation } from 'react-i18next';
import EmailForm from './EmailForm';

const ForgotPresentational = () => {
  const { t } = useTranslation();
  return (
    <div className="bg-grey-custom flex flex-col items-center justify-center py-16 px-4">
      <h1 className="text-5xl font-sans font-bold mb-8">
        {t('YOUR_PASSWORD')}
      </h1>
      <div className="bg-white overflow-hidden shadow rounded-lg w-full lg:w-1/2">
        <div className="py-10 px-4 md:px-8">
          <EmailForm />
        </div>
      </div>
    </div>
  );
};

export default ForgotPresentational;
